import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useTheme } from '../context/ThemeContext';
import { ACCENT_COLOR_OPTIONS } from '../theme/accentColors';

const ThemeColorPicker = () => {
  const { accentColor, colors, setAccentColor } = useTheme();

  return (
    <View style={styles.grid}>
      {ACCENT_COLOR_OPTIONS.map((option) => {
        const selected = accentColor === option.id;
        return (
          <TouchableOpacity
            key={option.id}
            style={[
              styles.chip,
              {
                borderColor: selected ? option.swatch : colors.border,
                backgroundColor: colors.surface,
              },
            ]}
            onPress={() => setAccentColor(option.id)}
            accessibilityRole="button"
            accessibilityLabel={`${option.label} theme color`}
            accessibilityState={{ selected }}
          >
            <View style={[styles.swatch, { backgroundColor: option.swatch }]} />
            <Text
              style={[
                styles.chipText,
                {
                  color: colors.text.primary,
                  fontWeight: selected ? '600' : '400',
                },
              ]}
            >
              {option.label}
            </Text>
          </TouchableOpacity>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
    marginTop: 8,
  },
  chip: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 10,
    borderWidth: 2,
    minWidth: '47%',
    flexGrow: 1,
  },
  swatch: {
    width: 18,
    height: 18,
    borderRadius: 9,
    marginRight: 8,
  },
  chipText: {
    fontSize: 14,
  },
});

export default ThemeColorPicker;
